/* eslint-disable class-methods-use-this */
// import logger from "@FRAMEWORK/utils/logger";
import logger from "@FRAMEWORK/utils/logger";
import React, {ReactNode} from "react";

type ErrorProps = {
	FallbackComponent?: ReactNode;
	children: ReactNode;
	logMsg?: string;
};
type ErrorState = {
	hasError: boolean;
};

class ErrorBoundary extends React.Component<ErrorProps, ErrorState> {
	state: ErrorState = {
		hasError: false,
	};
	constructor(props) {
		super(props);
		// console.log(props);
		// Define a state variable to track whether is an error or not
		this.state = {...this.state, hasError: false};
	}
	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI
		return {hasError: true};
	}
	componentDidCatch(error, info) {
		try {
			const status: number | undefined = error?.response?.status ?? error?.status;
			const isAxios = error?.isAxiosError === true || !!error?.response;

			// 인증 만료/권한 없음(401)은 정상 흐름이므로 로그 제외
			if (isAxios && status === 401) return;

			const data: {[key: string]: unknown} = {
				ua: navigator.userAgent,
				cutomMessage: this.props.logMsg || "",
				referer: location.href,
				site: "ErrorBoundary",
				componentStack: info?.componentStack,
			};
			if (isAxios) {
				data.message = error.message;
				data.code = error.code;
				data.status = status;
				data.url = error.config?.url;
				data.method = error.config?.method;
				data.responseData = error.response?.data;
			} else {
				error && (data.error = error);
				info && (data.info = info);
			}

			logger.error({...data});
		} catch (e) {}
	}
	render() {
		// Check if the error is thrown
		// console.log("render");
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return this.props.FallbackComponent || <></>;
		}

		// Return children components in case of no error

		return this.props.children;
	}
}

export default ErrorBoundary;
